/**
 * Nettoyage forcé des résidus de modales Bootstrap.
 *
 * Symptôme corrigé : après ouverture/fermeture de modales, un `.modal-backdrop`
 * résiduel et/ou la classe `modal-open` (+ overflow/padding) restent collés au
 * <body> et bloquent TOUS les clics sur la page.
 *
 * IMPORTANT — on NE fait PLUS `removeChild` sur les backdrops : react-bootstrap
 * les rend via un portail React et en reste propriétaire jusqu'à la fin du
 * démontage. Les retirer nous-mêmes désynchronise React, qui plante ensuite en
 * voulant les retirer à son tour ("removeChild: node is not a child of this
 * node"), crash aléatoire observé en navigation.
 *
 * On se contente donc de NEUTRALISER les backdrops résiduels (display:none +
 * pointer-events:none) : la page redevient cliquable immédiatement, et React
 * retire ses propres nœuds proprement par la suite. Les backdrops réellement
 * orphelins restent cachés et inoffensifs.
 *
 * Cas des modales empilées : si une modale est encore ouverte mais qu'il y a
 * plus de backdrops que de modales `.show`, les backdrops en trop (les plus
 * anciens) sont orphelins et neutralisés ; les `openModalCount` derniers,
 * présumés appartenir aux modales encore ouvertes, restent intacts.
 */
export function modalCleanup() {
  requestAnimationFrame(() => {
    setTimeout(() => {
      const openModalCount = document.querySelectorAll('.modal.show').length;
      const backdrops = document.querySelectorAll('.modal-backdrop');

      if (openModalCount > 0) {
        // Autant (ou moins) de backdrops que de modales ouvertes : tous légitimes, ne touche à rien.
        if (backdrops.length <= openModalCount) return;

        // Backdrops surnuméraires (modales empilées mal démontées) : on neutralise
        // uniquement les plus anciens, en laissant intacts les `openModalCount`
        // derniers (ceux des modales actuellement ouvertes, propriété de React).
        Array.from(backdrops)
          .slice(0, backdrops.length - openModalCount)
          .forEach((el) => {
            el.style.display = 'none';
            el.style.pointerEvents = 'none';
          });
        return;
      }

      backdrops.forEach((el) => {
        el.style.display = 'none';
        el.style.pointerEvents = 'none';
      });
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
    }, 0);
  });
}
